module.exports = __webpack_public_path__ + "static/media/orange.7d4b9b3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/orange.svg
// module id = 74
// module chunks = 0